import { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components"
import { MaterialIcon } from "../shared/MaterialIcon";

export const PasswordStrength = ({firstPassword, secondPassword, setPasswordValidFunction}) => {

    const [passwordLevel, setPasswordLevel] = useState(1);
    const [passwordLevelChecklist, setPasswordLevelChecklist] = useState({
        passwordLength: false,
        uppercaseLetter: false,
        lowercaseLetter: false,
        number: false,
        specialSign: false,
        passwordEqual: false,
    });

    useEffect(() => {
        if(firstPassword && firstPassword.trim().length)
        {
            let checklist = {
                passwordLength: firstPassword.length >= 6 ? true : false,
                uppercaseLetter: /\p{Lu}/u.test(firstPassword),
                lowercaseLetter: /\p{Ll}/u.test(firstPassword),
                number: /\p{N}/u.test(firstPassword),
                specialSign: /[^\p{L}\p{N}]/u.test(firstPassword),
                passwordEqual: firstPassword.trim() === secondPassword.trim()
            }
            
            setPasswordLevelChecklist({
                ...checklist
            })

            const level = classifyPassword(firstPassword);
            setPasswordLevel(level);

            if(Object.values(checklist).every(Boolean))
            {
                setPasswordValidFunction?.(true);
            }
            else
            {
                setPasswordValidFunction?.(false);
            }

        }


        

        // eslint-disable-next-line
    }, [firstPassword, secondPassword, setPasswordLevelChecklist, setPasswordValidFunction])
 
    return (
        <StyledPasswordStrength>
            <div className="passwordStatus">
                <span>Styrke: </span>
                {
                    passwordLevel === 3 ? "Sterk" : passwordLevel === 2 ? "Moderat" : passwordLevel === 1 ? "Lett" : null
                }
            </div>
            <div className="strengthBar">
                <div className={passwordLevel >= 1 ? 'passwordEasy levelActive' : 'passwordEasy'}/>
                <div className={passwordLevel >= 2 ? 'passwordMedium levelActive' : 'passwordMedium'}/>
                <div className={passwordLevel >= 3 ? 'passwordStrong levelActive' : 'passwordStrong'}/>
            </div>
            <div className="passwordChecklist">
                <PasswordCheckListElement req='Identiske passord' valid={passwordLevelChecklist.passwordEqual}/>
                <PasswordCheckListElement req='Minst 6 tegn' valid={passwordLevelChecklist.passwordLength}/>
                <PasswordCheckListElement req='Inneholder store bokstaver' valid={passwordLevelChecklist.uppercaseLetter}/>
                <PasswordCheckListElement req='Inneholder små bokstaver' valid={passwordLevelChecklist.lowercaseLetter}/>
                <PasswordCheckListElement req='Inneholder tall' valid={passwordLevelChecklist.number}/>
                <PasswordCheckListElement req='Inneholder spesialtegn' valid={passwordLevelChecklist.specialSign}/>
            </div>
        </StyledPasswordStrength>
    )
}

const StyledPasswordStrength = styled.div`

    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.md};

    div.passwordStatus
    {
        span
        {
            font-weight: 500;
        }
    }

    div.strengthBar
    {
        height: 5px;
        width: 100%;
        display: flex;
        gap: ${({theme}) => theme.spacing.sm};
        
        div.passwordEasy, div.passwordMedium, div.passwordStrong
        {
            flex: 1;
            background: ${({theme}) => theme.colors.neutralPrimaryBorder};
        }

        div.passwordEasy.levelActive
        {
            background: ${({theme}) => theme.colors.successForeground};
        }

        div.passwordMedium.levelActive
        {
            background: ${({theme}) => theme.colors.warningForeground};
        }

        div.passwordStrong.levelActive
        {
            background: ${({theme}) => theme.colors.errorForeground};
        }
    }

    div.passwordChecklist
    {
        display: flex;
        gap: ${({theme}) => theme.spacing.sm};
        flex-direction: column;
    }

`

const PasswordCheckListElement = ({req = '', valid}) => {

    const theme = useTheme();

    return (
        <StyledPasswordCheckListElement>
            <div
                className="checkbox"
                style={{color: valid ? theme.colors.successForeground : theme.colors.errorForeground}}
            >
                <MaterialIcon
                    name={valid ? 'check' : 'close'}
                    weight={300}
                />
            </div>
            <div className="text">
                {req}
            </div>
        </StyledPasswordCheckListElement>
    )
}

const StyledPasswordCheckListElement = styled.div`
    display: flex;
    gap: ${({theme}) => theme.spacing.sm};
    
    div.checkbox
    {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

const classifyPassword = (password) => {
    const lowerCount = (password.match(/[a-z]/g) || []).length;
    const upperCount = (password.match(/[A-Z]/g) || []).length;
    const digitCount = (password.match(/[0-9]/g) || []).length;
    const specialCount = (password.match(/[^a-zA-Z0-9]/g) || []).length;

    const length = password.length;

    if(
        length < 6 ||
        lowerCount < 1 ||
        upperCount < 1 ||
        digitCount < 1 ||
        specialCount < 1
    )
    {
        return 1;
    }

    let score = 0;

    if(length >= 6 && length <= 8) score += 1;
    else if(length >= 9 && length <= 12) score += 2;
    else if(length >= 13) score += 3;

    if(lowerCount >= 3) score += 1;
    if(upperCount >= 2) score += 1;
    if(digitCount >= 2) score += 1;
    if(specialCount >= 2) score += 1;

    score += 1;

    let level;

    if(score <= 3) level = 1;
    else if(score <= 5) level = 2;
    else level = 3;

    return level;
}